import styled from "styled-components";
import { SpaceProps, space } from "styled-system";

import Box from "../Box/Box";
import Icon, { IconWeight } from "../Icon/Icon";
import ResponsiveLayout from "../ResponsiveLayout/ResponsiveLayout";
import Typography from "../Typography/Typography";

import { AlertProps } from "./alert.type";

const SyledResponsiveLayout = styled(ResponsiveLayout)<SpaceProps>`
  ${space}
`;

const variants = {
  info: {
    icon: "exclamation-circle",
    iconWeight: "regular",
    iconWidth: "24px",
    iconHeight: "24px",
    color: "informative-text-color",
  },
};

export default function Alert({
  title,
  children,
  variant = "info",
  icon,
  iconWeight,
  iconColor,
  iconWidth,
  iconHeight,
  width = "auto",
  paddingX = 0,
  paddingY = 5,
  ...props
}: AlertProps) {
  return (
    <Box
      width={width}
      paddingY={paddingY}
      role="alert"
      bg="informative-background-color"
      color="informative-text-color"
      {...props}
    >
      <SyledResponsiveLayout paddingX={paddingX ? paddingX : undefined}>
        <Box display="flex" alignItems="center">
          <Icon
            name={icon || variants[variant]?.icon}
            color={iconColor || variants[variant]?.color}
            weight={iconWeight || (variants[variant]?.iconWeight as IconWeight)}
            width={iconWidth || variants[variant]?.iconWidth}
            height={iconHeight || variants[variant]?.iconHeight}
          />
          <Typography
            m={0}
            ml={3}
            color={variants[variant]?.color}
            variant="body"
            htmlTag="h6"
            css={`
              font-weight: 500;
              flex: 1;
            `}
          >
            {title}
          </Typography>
        </Box>
        {children}
      </SyledResponsiveLayout>
    </Box>
  );
}
